import { render, staticRenderFns } from "./KasbonOutstanding.vue?vue&type=template&id=2a84fbb2"
import script from "./KasbonOutstanding.vue?vue&type=script&lang=js"
export * from "./KasbonOutstanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports